import React from 'react'
import Styles from '../styles/App.scss'
import TweetContents from './TweetContents'
import Icon from './Icons'

class Tweet extends React.Component{

  render() {   

  	const {userName, handle, tweetId, timestamp, image, video} = this.props    
 
	 return(
	 	
		  <div className='tweet'>
		  	<a className='tweet-header' href={`https://twitter.com/${handle}/status/${tweetId}`} target='_blank'>
		  		<div className='tweet-header-profilePic'>  			
		  			<img src={`https://assets.plickers.com/staticsite-assets/tweets/profile-pics/${tweetId}_profile.jpg`} />  			
		  		</div>
		  		<div className='tweet-header-right'>
		  			<div className='tweet-header-userName'>
		  				{userName}
		  			</div>
		  			<div className='tweet-header-handle'>
		  				@{handle}
		  			</div>
		  		</div>
		  		<div className='tweet-header-link'>
		  			<Icon iconName='twitter-logo' />
		  		</div>
		  	</a>
	  		<div className='tweet-contents'>
		  		{tweetId &&
		  			<TweetContents tweetId={tweetId} />
		  		}
		  		{image &&
		  			<div className='tweet-contents-imgContainer'>
		  				<img 
		  					className='tweet-contents-img'
		  					src={`https://assets.plickers.com/staticsite-assets/tweets/photos/${tweetId}_photo_320w.jpg`} 
		  					srcSet={`https://assets.plickers.com/staticsite-assets/tweets/photos/${tweetId}_photo_320w.jpg 1x, https://assets.plickers.com/staticsite-assets/tweets/photos/${tweetId}_photo_640w.jpg 2x`} 
		  				/>
		  			</div>
		  		}
		  		{video &&
		  			<div className='tweet-contents-vidContainer'>
		  				<video
		  					width="325px"
		  					height="479px"
		  					controls
		  					preload
		  					controlsList="nodownload">
		  				>
		  					<source 
		  						src={`https://assets.plickers.com/staticsite-assets/tweets/videos/${tweetId}_video.mp4`}
		  						type="video/mp4"
		  					/>	
		  				</video>
		  			</div>
		  		}
		  	</div>

		  	<div className='tweet-timestamp'>
		  		{timestamp}
		  	</div>	    
		 	</div>

		)
	}
}

export default Tweet
